<template>
	<div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;">
		<div class="titleView">
			<el-row>
				<el-col :span="5">
					<div style="font-size: 16px;font-weight: bold;padding:0 10px;">资产采购单详情</div>
				</el-col>
				<el-col :span="4" :offset="15">
					<el-button type="warning" @click="down" size="small">导出发货单</el-button>
					<el-button type="warning" @click="back" size="small">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="titleView" style="line-height: 30px;">
			<el-row>
				<el-col :span="6">发货单号: {{detail.purchaseNo}}</el-col>
				<el-col :span="6">创建时间: {{detail.createOperationInfo&&detail.createOperationInfo.operationTime}}</el-col>
				<el-col :span="6">创建人: {{detail.createOperationInfo&&detail.createOperationInfo.userName}}</el-col>
				<el-col :span="6">状态: {{detail.state&&detail.state.name}}</el-col>
				<el-col :span="6">发往门店: {{detail.shopInfo&&detail.shopInfo.shopName}}</el-col>
				<el-col :span="6">验收时间: </el-col>
				<el-col :span="6">验收人: </el-col>
				<el-col :span="6">备注: {{detail.purchaseRemark}}</el-col>
			</el-row>
		</div>
		<div class="shopClass">
			<el-table ref="multipleTable1" :data="detail.purchaseDetailList" tooltip-effect="dark" size="small">
				<el-table-column label="编号">
					<template slot-scope="scope">
						{{scope.row.assetsCode}}
					</template>
				</el-table-column>
				<el-table-column label="名称">
					<template slot-scope="scope">
						{{scope.row.assetsName}}
					</template>
				</el-table-column>
				<el-table-column label="规格">
					<template slot-scope="scope">
						{{scope.row.skuName}}
					</template>
				</el-table-column>
				<el-table-column label="价格">
					<template slot-scope="scope">
						{{scope.row.purchasePrice}}
					</template>
				</el-table-column>
				<el-table-column prop="goods_count" label="数量" align="center">
					<template slot-scope="scope">
						{{scope.row.count}}
					</template>
				</el-table-column>
				<el-table-column label="发货总价" align="center">
					<template slot-scope="scope">
						{{$public.cheng(scope.row.purchasePrice,scope.row.count)}}
					</template>
				</el-table-column>
				<el-table-column label="备注" align="center">
					<template slot-scope="scope">
						{{scope.row.purchaseRemark}}
					</template>
				</el-table-column>
				<el-table-column label="状态" align="center">
					<template slot-scope="scope">
						{{scope.row.purchaseState.name}}
					</template>
				</el-table-column>
				<el-table-column label="验收状态" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.purchaseState.id!=='1'">
							<div>已验收：{{scope.row.acceptInfo.officialReceipts}}</div>
							<div>
								已拒收：{{scope.row.acceptInfo.rejectionCount}}
								<el-tooltip effect="dark" placement="bottom-start">
									<div slot="content" class="tip">
										{{scope.row.acceptInfo.rejectionRemark}}
									</div>
									<img style="width:20px;vertical-align: middle;margin-left:5px;" src="../../../assets/img/icon_eye.jpg" />
								</el-tooltip>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button @click="curRow=scope.row;drawerSeeProduct_state=true" type="text" size="small">资产信息</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="drawerSeeProduct_state">
			<drawerSeeProduct :id="curRow.assetsCode" @submit="drawerSeeProduct_state=false"></drawerSeeProduct>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import drawerSeeProduct from "./drawer_seeProduct.vue"
	export default {
		components: {
			drawerSeeProduct
		},
		data() {
			return {
				fixedHeight: 0,

				detail: {},
				drawerSeeProduct_state: false,
				curRow: {},
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;

			let loading = this.$loading()
			this.$http.get(process.env.VUE_APP_zichan + '/api/AssetsPurchase/detail', {
				id: this.$route.query.id,
			}).then(res => {
				loading.close()
				if (res.code == 0) {
					this.detail = res.data
				}
			})
		},
		methods: {
			back() {
				this.$router.go(-1)
			},
			down() {
				let loading = this.$loading()
				axios.get(process.env.VUE_APP_zichan + '/api/AssetsPurchase/upload', {
					params: {
						id: this.$route.query.id,
					},
					responseType: 'blob'
				}).then(response => {
					var href = window.URL.createObjectURL(response.data); //创建下载的链接
					var downloadElement = document.createElement('a');
					downloadElement.href = href;
					downloadElement.download = '资产发货单导出.xlsx';
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放掉blob对象
					loading.close();
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		height: 100%;

		// 重复头部
		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.remarks {
			margin-top: 20px;
			display: flex;

			.labelRemark {
				font-size: 14px;
				margin-right: 10px;
			}
		}

		.fix_btn {
			position: absolute;
			bottom: 0;
			z-index: 6;
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;

			button {
				margin-right: 30px;
			}

			button:nth-of-type(5) {
				margin-right: 60px;
			}
		}
	}
</style>
